import _XCircleIcon from "@adsk/alloy-react-icon/es/lib/XCircleIcon";
import _AlertWarningIcon from "@adsk/alloy-react-icon/es/lib/AlertWarningIcon";
import _CheckmarkCircleIcon from "@adsk/alloy-react-icon/es/lib/CheckmarkCircleIcon";
import _AlertInformationIcon from "@adsk/alloy-react-icon/es/lib/AlertInformationIcon";
import _styled from "styled-components";
const _excluded = ["style", "className", "status"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { variantSwitch } from '@adsk/alloy-react-helpers';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import { NOTIFICATION_STATUSES } from './helpers/consts';
const mapNotificationStatusToIconRenderer = {
  [NOTIFICATION_STATUSES.NONE]: () => null,
  [NOTIFICATION_STATUSES.INFO]: p => /*#__PURE__*/React.createElement(_AlertInformationIcon, p),
  [NOTIFICATION_STATUSES.SUCCESS]: p => /*#__PURE__*/React.createElement(_CheckmarkCircleIcon, p),
  [NOTIFICATION_STATUSES.WARNING]: p => /*#__PURE__*/React.createElement(_AlertWarningIcon, p),
  [NOTIFICATION_STATUSES.ERROR]: p => /*#__PURE__*/React.createElement(_XCircleIcon, p)
};
const NotificationIcon = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style,
      className,
      status = NOTIFICATION_STATUSES.INFO
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const renderIcon = mapNotificationStatusToIconRenderer[status];
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({}, props, {
    ref: ref,
    className: className,
    $_css: [{
      width: 24,
      height: 24
    }, variantSwitch({
      statement: status,
      variants: {
        [NOTIFICATION_STATUSES.INFO]: {
          color: theme.tokens.colors.icon.information.value
        },
        [NOTIFICATION_STATUSES.SUCCESS]: {
          color: theme.tokens.colors.icon.success.value
        },
        [NOTIFICATION_STATUSES.WARNING]: {
          color: theme.tokens.colors.icon.warning.value
        },
        [NOTIFICATION_STATUSES.ERROR]: {
          color: theme.tokens.colors.icon.error.value
        }
      }
    }), style]
  }), renderIcon === null || renderIcon === void 0 ? void 0 : renderIcon({}));
});
NotificationIcon.displayName = 'Notifications';
NotificationIcon.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Notification status */
  status: PropTypes.oneOf(Object.values(NOTIFICATION_STATUSES))
};
export default NotificationIcon;
var _StyledDiv = _styled("div").withConfig({
  displayName: "NotificationIcon___StyledDiv",
  componentId: "sc-zey28s-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=NotificationIcon.js.map